import { axiosInstance } from './api';
import * as ActionTypes from '../store/ActionTypes';

export const actionCreators = {
    getBranches: (branches) => ({ type: ActionTypes.getBranches, payload: branches }),
    getProductHistoryById: (product) => ({ type: ActionTypes.getProduct, payload: product }),
    updateProduct: (product) => ({ type: ActionTypes.updateProduct, payload: product }),
    createProduct: (product) => ({ type: ActionTypes.createProduct, payload: product }),
    setProduct: (product) => ({ type: ActionTypes.getProduct, payload: product }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response})
}

export const getProductHistoryById = (callback, context, id) => {
    return dispatch => {
            const url = `ProductHistory/GetProductHistoryById/${id}`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getProductHistoryById(response.data.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}

export const getBranches = (callback, context) => {
    return dispatch => {
            const url = `Branch/GetAllBranches`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getBranches(response.data.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}

export const updateProductHistory = (product) => {
    return dispatch => {
        const url = `Product/PutAsync`;
        return axiosInstance().put(url, product).then(response => {
            dispatch(actionCreators.updateProductHistory(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}